import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ClassifierListItem, CreateClassifierValueRequest, ClassifierValueCard } from 'types/classifier.interface';
import { AbstractControl, FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { SpinnerComponent } from 'components/spinner/spinner.component';
import { BaseFormModalComponent } from '../base-form-modal.component';
import { ToastService } from 'services/toast.service';
import { getControlsWithErrors, MAX_LENGTH_NAME } from 'util/form.utility';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-add-classifier-value',
  standalone: true,
  imports: [TranslateModule, FormsModule, SpinnerComponent, ReactiveFormsModule, NgClass],
  templateUrl: './add-classifier-value.component.html',
  styleUrl: './add-classifier-value.component.scss'
})
export class AddClassifierValueComponent extends BaseFormModalComponent implements OnInit {
  @Input() classifier!: ClassifierListItem;
  @Input() siblingValues: ClassifierValueCard[] = [];
  @Output() save: EventEmitter<CreateClassifierValueRequest> = new EventEmitter<CreateClassifierValueRequest>();
  isUniqueValue: boolean = true;

  get name(): AbstractControl<any, any> | null {
    return this.form.get('name');
  }

  constructor(
    formBuilder: FormBuilder,
    config: NgbModalConfig,
    modalService: NgbModal,
    toastService: ToastService,
    translateService: TranslateService
  ) {
    super(formBuilder, config, modalService, toastService, translateService);
  }

  ngOnInit() {
    this.fillForm();
  }

  fillForm(): void {
    this.form = this.formBuilder.group({
      name: ['', [Validators.required, Validators.maxLength(MAX_LENGTH_NAME)]]
    });
  }

  handleSave() {
    const args: CreateClassifierValueRequest = {
      classifierId: this.classifier.id,
      name: this.name?.value,
      description: '',
      code: `${this.classifier.code}.${this.name?.value.split(' ').join('_').toUpperCase()}`
    };

    if (this.form.valid && this.validateUniqueValue()) {
      this.submitAttempted = false;
      this.save.emit(args);
    } else {
      this.submitAttempted = true;
      if (this.isUniqueValue) {
        this.toastService.showFormValidationError(getControlsWithErrors(this.form), 'components.editClassifierGroup');
      } else {
        this.toastService.showDanger('notUniqueError', '', {
          shouldTranslate: true
        });
      }
    }
  }

  resetForm(): void {
    this.name?.setValue('');
    this.name?.markAsUntouched();
    this.name?.markAsPristine();
  }

  protected override close(): void {
    this.resetForm();
    super.close();
  }

  validateUniqueValue(): boolean {
    this.isUniqueValue = !this.siblingValues.some(
      (value) => !value.isDeleted && value.name!.toLowerCase() === this.name?.value.toLowerCase()
    );

    return this.isUniqueValue;
  }
}
